import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { FontWeight, Colors, radii, InformationIcon, SuccessIcon, WarningIcon } from "../../index";
import { Label2 } from "../Text";
function VariantStyle(variant) {
    switch (variant) {
        case "information":
            return {
                Icon: InformationIcon,
                bg: `${Colors.blue}.2`
            };
        case "information-light":
            return {
                color: `${Colors.grey}.0`,
                Icon: InformationIcon,
                border: "1px solid",
                borderColor: `${Colors.grey}.2`
            };
        case "error":
            return {
                Icon: WarningIcon,
                bg: `${Colors.red}.2`
            };
        case "success":
            return {
                Icon: SuccessIcon,
                bg: `${Colors.green}.0`
            };
    }
}
export const NotificationCard = ({ title, id, message, showIcon = true, variant = "information" }) => {
    const StylesAndIcons = VariantStyle(variant);
    const shouldShowIcon = showIcon && StylesAndIcons.Icon;
    return (_jsxs(Flex, { id: id, sx: {
            color: StylesAndIcons.color || `${Colors.white}.0`,
            bg: StylesAndIcons.bg,
            borderRadius: radii.clickable,
            border: StylesAndIcons.border,
            borderColor: StylesAndIcons.borderColor || "transparent",
            py: 24,
            px: shouldShowIcon ? 16 : 24
        }, children: [shouldShowIcon && (_jsx(Box, { sx: { width: 24 }, children: _jsx(StylesAndIcons.Icon, {}) })), _jsxs(Flex, { sx: {
                    flexDirection: "column",
                    ml: shouldShowIcon ? 12 : 0,
                    flex: 1
                }, children: [title && (_jsx(Label2, { sx: {
                            fontWeight: FontWeight.textBold,
                            mb: 4
                        }, children: title })), _jsx(Label2, { children: message })] })] }));
};
//# sourceMappingURL=NotificationCard.js.map